export const stepMarking = [];
// export const stepMarking = ['fas', 'shoe-prints'];
export const initialMarking = ['fas', 'person'];
export const currentMarking = ['fas', 'person-running-fast'];

export const clssNameRow = (generalPosition, lgMin, lgMax) =>
  lgMax === lgMin ? 'justify-center' : generalPosition === lgMin ? 'justify-end' : generalPosition === lgMax ? 'justify-start' : 'justify-center';

export const clssNameColumn = (generalPosition, lgMin, lgMax) =>
  lgMax === lgMin ? 'items-center' : generalPosition === lgMin ? 'items-start' : generalPosition === lgMax ? 'items-end' : 'items-center';

export const styleColumn = (width, generalPosition, lgMin, lgMax) => {
  const bottom = lgMax > generalPosition ? '0px' : '0.5rem';
  const top = lgMin < generalPosition ? '0px' : '0.5rem';
  return {
    marginLeft: '-1.5px',
    position: 'absolute',
    left: width / 2,
    //   left: `calc(${width / 2}px + 0.5rem)`,
    borderLeft: `3px dashed var(--muted-foreground)`,
    height:
      lgMin === lgMax
        ? '0%'
        : lgMin === generalPosition || lgMax === generalPosition
        ? `calc(100% - ${bottom} - ${top})`
        : '100%',
    bottom,
    top
  };
};

export const styleRow = (width, generalPosition, lgMin, lgMax) => {
  const left = lgMax > generalPosition ? '0px' : '0.5rem';
  const right = lgMin < generalPosition ? '0px' : '0.5rem';
  return {
    borderBottom: `3px dashed var(--muted-foreground)`,
    position: 'absolute',
    bottom: `calc(${width / 2}px + 0.5rem)`,
    width:
      lgMin === lgMax
        ? '0%'
        : lgMin === generalPosition || lgMax === generalPosition
        ? `calc(100% - ${left} - ${right})`
        : '100%',
    left,
    right
  };
};
